import { useMyContext } from "Context/MyContextProvider";
import { SECONDARY } from "../../CustomUtils.js/utils";
export const landingButtonGradient =
  "linear-gradient(90deg, #21b573 20%, #43e97b 100%)";
export const CustomBadge = ({ text, minWidth = 0 }) => {
  const { isMobile } = useMyContext();
  return (
    <span
      // className={}
      style={{
        background: "rgba(33,181,115,0.12)",
        color: SECONDARY,
        display: "inline-block",
        fontWeight: 600,
        fontSize: 15,
        borderRadius: 8,
        padding: "4px 16px",
        marginBottom: 18,
        marginTop : isMobile ? '1rem' : 0,
        // minWidth: minWidth,
        letterSpacing: "0.5px",
      }}
    >
      {text}
    </span>
  );
};
